import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import "../styles/Login.css";

import { getDatabase, ref, onValue } from "firebase/database";

import Logo from "../../assets/logo1.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        username,
        password
      );
      const user = userCredential.user;

      // Buscar no Realtime Database
      const db = getDatabase();
      const corretoresRef = ref(db, "corretores");

      onValue(
        corretoresRef,
        (snapshot) => {
          const data = snapshot.val();

          if (data) {
            const corretorID = Object.keys(data).find(
              (key) =>
                data[key].email.trim().toLowerCase() ===
                username.trim().toLowerCase()
            );

            if (corretorID) {
              localStorage.setItem("corretorID", corretorID);
              localStorage.setItem("auth", "true");
              navigate("/panel/dashboard");
            } else {
              setError("Corretor não encontrado no banco de dados.");
            }
          } else {
            setError("Erro ao buscar dados do corretor.");
          }
        },
        {
          onlyOnce: true,
        }
      );
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setError("Usuário não encontrado. Verifique o CRECI ou email.");
      } else if (error.code === "auth/wrong-password") {
        setError("Senha incorreta. Tente novamente.");
      } else {
        setError("Erro ao fazer login. Tente novamente.");
      }
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <img src={Logo} alt="Logo" className="logoLogin" />
        <h1>Login Administrativo</h1>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label htmlFor="username">Email</label>
          <input
            type="email"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Senha</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">
          Entrar
        </button>
      </form>
    </div>
  );
};

export default Login;
